import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SobResponse } from '../../../../models/http/sob-http.model';
import { ThousandsDotPipe } from '../../../../../../shared/pipes/thousands-dot.pipe';
import { SobGrouped } from './models/sob-group.model';
import { SobModalListService } from './services/sob-modal-list.service';
import { CoverageType } from '../../../../models/sob.enum';
import { BenefitValueTypePipe } from '../../../../pipes/benefit-value-type.pipe';

@Component({
  selector: 'app-sob-modal-list',
  standalone: true,
  imports: [CommonModule, ThousandsDotPipe, BenefitValueTypePipe],
  templateUrl: './sob-modal-list.component.html',
  styleUrl: './sob-modal-list.component.scss',
})
export class SobModalListComponent {
  private _sobData!: SobResponse;
  groupedBenefits: SobGrouped[] = [];

  coverageType = CoverageType;

  private sobModalListService = inject(SobModalListService);

  @Input()
  set sobData(value: SobResponse) {
    this._sobData = value;
    if (value) {
      this.groupedBenefits = this.sobModalListService.groupBenefits(value);
    }
  }

  get sobData(): SobResponse {
    return this._sobData;
  }
}
